import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    acctype: localStorage.getItem("acctype") || "",
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, user) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    set_acctype(state, acctype) {
      state.acctype = acctype;
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = "";
      state.acctype = "";
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          // url: `${Vue.prototype.$hostname}/api/login`,
          url: `${Vue.prototype.$hostname}/api/auth/login`,
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;

            const acctype = user.acctype;
            const useremail = user.email;
            const userf = user.name + " " + user.surname;

            localStorage.setItem("token", token);
            localStorage.setItem("acctype", acctype);
            localStorage.setItem("useremail", useremail);
            localStorage.setItem("fullname", userf);

            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;
            commit("set_acctype", acctype);
            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${Vue.prototype.$hostname}/api/register`,
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            // Add the following line:
            axios.defaults.headers.common["Authorization"] = token;

            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    userAccess: (state) => state.user,
    roleAccess: function (state) {
      return state.acctype;
    },
  },
});
